<!-- ═══ TABLE ROW VIEW ═══ -->
<ng-container *ngIf="!cardMode">
  <div class="list-item row align-items-center" [class.row-entrance]="dataLoaded">
    <div class="item-name col-lg-3 col-7">
      <div class="d-flex align-items-center">
        <a class="favorite-star" (click)="onToggleFavorite($event)">
          <i class="icon" [class.icon-star-active]="isFavorite" [class.icon-star-inactive]="!isFavorite"></i>
        </a>
        <a [routerLink]="['/prices', pair]" class="link row no-gutters align-items-center flex-grow-1">
          <currency class="col-auto" [currency]="currency?.code" [useDefaultTheme]="true"></currency>
          <div class="info col">
            <div class="row">
              <div class="name col-lg-auto">{{currency?.name}}</div>
              <div class="code col-lg-auto">{{currency?.code}}</div>
            </div>
            <div class="market-cap" *ngIf="currency?.marketCap?.amount && +currency.marketCap.amount > 0">
              <span i18n="@@cryptoPrices.row.mcap">MCap</span> ${{ currency.marketCap.amount | compactNumberFormat:1000:'0.2-2':1000000:'0.0-0':2 }}
            </div>
          </div>
        </a>
      </div>
    </div><!-- .item-name -->
    <a class="item-data col-5 col-lg-4 align-items-center" [routerLink]="['/prices', pair]">
      <ng-container *ngIf="currency; else noData">
        <div class="row">
          <div class="d-flex flex-column item-price col-lg-6">
            <ng-container *ngIf="data?.defaultCurrency?.lastPrice else noValue">
              <div class="item-price text-black" [ngClass]="priceFlashClass">
                {{data?.baseCurrency?.currency}} {{data?.baseCurrency?.lastPrice || 0 | roundNumberPrice}}
              </div>
              <div class="item-price text-sm text-gray" *ngIf="useGlobalCurrency && data?.baseCurrency?.currency !== data?.defaultCurrency?.currency">
                {{data?.defaultCurrency?.currency}} {{data?.defaultCurrency?.lastPrice || 0 | roundNumberPrice}}
              </div>
            </ng-container>
          </div>
          <div class="item-change col-lg-6 d-flex align-items-center">
            <ng-container *ngIf="(data?.priceChangePercentage || data?.priceChangePercentage === 0) && !loading; else noValue">
              <div class="text-bold ltr" [ngClass]="data?.isPositvitePriceChange ? 'change-badge-primary' : 'change-badge-danger'">
                {{data?.isPositvitePriceChange ? '+': ''}}{{data?.priceChangePercentage || 0 | number:'0.2-2'}}%
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </a>
    <div class="col-lg-2 d-none d-lg-block">
      <ng-container *ngIf="!loading && data; else chartSkeleton">
        <div #chartElm></div>
      </ng-container>
      <ng-template #chartSkeleton>
        <div class="skeleton-bar skeleton-chart"></div>
      </ng-template>
    </div>
    <div class="col-lg-1 d-none d-lg-block"></div>
    <div class="col-lg-2 g-0 d-none d-lg-flex">
      <div class="col">
        <a [routerLink]="['/prices', pair]" class="col btn btn-outline btn-block"
          i18n="@@cryptoPrices.actions.details">Details</a>
      </div>
      <div class="p-1"></div>
      <div class="col">
        <a [routerLink]="['/lite', 'exchange', 'buy']" [queryParams]="{to: currency?.code, from: baseCurrencyCode}"
          class="col btn btn-primary btn-block" i18n="@@cryptoPrices.actions.trade">Buy</a>
      </div>
    </div>
  </div><!-- .list-item -->
  <div class="mobile-chart-row" *ngIf="showCharts && data">
    <div #mobileChartElm></div>
  </div>
</ng-container>

<!-- ═══ CARD VIEW ═══ -->
<a *ngIf="cardMode" class="card-item" [routerLink]="['/prices', pair]">
  <!-- Row 1: identity left, price+change right -->
  <div class="card-header">
    <div class="card-identity">
      <currency [currency]="currency?.code" [useDefaultTheme]="true"></currency>
      <div class="card-name-block">
        <span class="card-name" [title]="currency?.name">{{currency?.name}}</span>
        <span class="card-code">{{currency?.code}}</span>
      </div>
    </div>
    <div class="card-price-block" [ngClass]="priceFlashClass">
      <ng-container *ngIf="currentPrice; else cardPriceSkeleton">
        <div class="card-price">{{data?.baseCurrency?.currency}} {{currentPrice | roundNumberPrice}}</div>
        <div class="card-change" *ngIf="data?.priceChangePercentage || data?.priceChangePercentage === 0" [ngClass]="data?.isPositvitePriceChange ? 'up' : 'down'">
          <span class="change-arrow">{{data?.isPositvitePriceChange ? '↗' : '↘'}}</span>
          {{data?.isPositvitePriceChange ? '+': ''}}{{data?.priceChangePercentage || 0 | number:'0.2-2'}}%
        </div>
      </ng-container>
      <ng-template #cardPriceSkeleton>
        <div class="skeleton-bar skeleton-price"></div>
      </ng-template>
    </div>
  </div>

  <!-- Row 2: area chart -->
  <div class="card-chart" *ngIf="showCharts">
    <ng-container *ngIf="!loading && data; else cardChartSkeleton">
      <div #cardChartElm></div>
    </ng-container>
    <ng-template #cardChartSkeleton>
      <div class="skeleton-bar skeleton-chart-card"></div>
    </ng-template>
  </div>

  <!-- Row 3: price range bar -->
  <div class="card-range" *ngIf="periodLow != null && periodHigh != null && currentPrice">
    <div class="range-labels">
      <span class="range-low"><span class="range-label">{{durationLabel}} Low</span> {{data?.baseCurrency?.currency}} {{periodLow | roundNumberPrice}}</span>
      <span class="range-high"><span class="range-label">{{durationLabel}} High</span> {{data?.baseCurrency?.currency}} {{periodHigh | roundNumberPrice}}</span>
    </div>
    <div class="range-track">
      <div class="range-fill" [style.width]="priceRangePercent"></div>
    </div>
  </div>

  <!-- Row 4: stats + favorite -->
  <div class="card-footer">
    <div class="card-stat">
      <span class="stat-label">MARKET CAP</span>
      <span class="stat-value" *ngIf="currency?.marketCap?.amount && +currency.marketCap.amount > 0; else dash">{{data?.baseCurrency?.currency}} {{ currency.marketCap.amount | compactNumberFormat:1000:'0.2-2':1000000:'0.0-0':2 }}</span>
    </div>
    <a class="favorite-star" (click)="onToggleFavorite($event)">
      <i class="icon" [class.icon-star-active]="isFavorite" [class.icon-star-inactive]="!isFavorite"></i>
    </a>
  </div>
</a>

<ng-template #noValue>
  <div class="skeleton-bar skeleton-price"></div>
</ng-template>

<ng-template #dash>
  <span class="stat-value">--</span>
</ng-template>

<ng-template #noData>
  <div class="skeleton-row">
    <div class="skeleton-bar skeleton-price-wide"></div>
    <div class="skeleton-bar skeleton-change"></div>
  </div>
</ng-template>
